import * as React from 'react';
import { DoubleInput, InputAdornment, UIHeading4 } from '@cian/ui-kit';

import { connectToDescriptors, IDescriptorProps } from '../сonnectToDescriptors';
import { totalAreaInputDescriptors } from '../../constants/descriptors';
import { TTypedThunkDispatch } from '../../types/thunk';
import { getOffersCount } from '../../actions/offersData';
import { updateTags } from '../../actions/filterTags';
import { debounce } from '@cian/newbuilding-utils';
import { DEFAULT_INPUT_TIMEOUT } from '../../constants/timeouts';

export interface ITotalAreaInputProps extends IDescriptorProps<number> {
  getOffersCount(): void;
  updateTags(): void;
}

class TotalAreaInputsComponent extends React.Component<ITotalAreaInputProps> {
  public getOffersCount = debounce(DEFAULT_INPUT_TIMEOUT, this.props.getOffersCount);

  public shouldComponentUpdate(nextProps: ITotalAreaInputProps) {
    const { gte: nextGte, lte: nextLte } = this.getValue(nextProps);
    const { gte, lte } = this.getValue(this.props);

    return nextGte !== gte || nextLte !== lte;
  }

  public getValue = ({ jsonQuery: { total_area } }: ITotalAreaInputProps) => {
    const gte = total_area && total_area.value ? total_area.value.gte : undefined;
    const lte = total_area && total_area.value ? total_area.value.lte : undefined;

    return { gte, lte };
  };

  public render() {
    const { actionCreator, descriptors } = this.props;
    const { gte, lte } = this.getValue(this.props);
    const action = (type: 'gte' | 'lte') => (value: number | undefined) => {
      actionCreator(descriptors[0])(value, type);
      this.props.updateTags();
      this.getOffersCount();
    };

    return (
      <DoubleInput
        label={<UIHeading4>Общая</UIHeading4>}
        dataTestId="inputs-multiple"
        onChangeFrom={action('gte')}
        onChangeTo={action('lte')}
        fromAdornments={{ left: <InputAdornment>от</InputAdornment>, right: <InputAdornment>м²</InputAdornment> }}
        toAdornments={{ left: <InputAdornment>до</InputAdornment>, right: <InputAdornment>м²</InputAdornment> }}
        value={[gte, lte]}
        ariaLabel={['Минимальная общая площадь квартиры', 'Максимальная общая площадь квартиры']}
      />
    );
  }
}

function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    getOffersCount: () => {
      dispatch(getOffersCount());
    },
    updateTags: () => {
      dispatch(updateTags());
    },
  };
}

export const TotalAreaInput = connectToDescriptors(
  totalAreaInputDescriptors,
  mapDispatchToProps,
)(TotalAreaInputsComponent);
